import { defaultInstance } from '@ciam/async-utils';

export const userApi = {
  getUserChannelList: async ({ email }: { email: string }) => {
    const { data } = await defaultInstance.post('/api/gigya/get-user-channel-list', { email });
    return data;
  },
  checkTenure: async ({ uid }: { uid: string }) => {
    const { data } = await defaultInstance.post('/api/gigya/check-tenure', { uid });
    return data;
  },
  getMfaException: async ({ email }: { email: string }): Promise<{ isMfaException: boolean }> => {
    const { data } = await defaultInstance.post('/api/gigya/get-mfa-exception', { email });
    return data;
  },
  getBioRequiredChannelList: async () => {
    const { data } = await defaultInstance.get('/getBioRequired');
    return data;
  },
  requestMfaLogin: async (params: { email: string; uid: string; isBioOnly: boolean; returnUrl: string }) => {
    const { email, uid, isBioOnly, returnUrl } = params;

    const { data } = await defaultInstance.post('/api/mfa/request', {
      email,
      uid,
      displayUid: email,
      isBioOnly,
      returnUrl,
    });
    return data;
  },
  validateJwtToken: async ({ jwtTokenResponse, isBioOnly }: { jwtTokenResponse: string; isBioOnly: boolean }) => {
    const { data } = await defaultInstance.post('/api/mfa/authenticate', {
      jwtTokenResponse,
      isBioOnly,
    });
    return data;
  },
};
